const CountryList = (translate) => {
    return [
        { name: translate("country.afghanistan"), code: 'AF' },
        { name: translate("country.aland_islands"), code: 'AX' },
        { name: translate("country.albania"), code: 'AL' },
        { name: translate("country.algeria"), code: 'DZ' },
        { name: translate("country.american_samoa"), code: 'AS' },
        { name: translate("country.andorra"), code: 'AD' },
        { name: translate("country.angola"), code: 'AO' },
        { name: translate("country.anguilla"), code: 'AI' },
        { name: translate("country.antarctica"), code: 'AQ' },
        { name: translate("country.antigua_and_barbuda"), code: 'AG' },
        { name: translate("country.argentina"), code: 'AR' },
        { name: translate("country.armenia"), code: 'AM' },
        { name: translate("country.aruba"), code: 'AW' },
        { name: translate("country.australia"), code: 'AU' },
        { name: translate("country.austria"), code: 'AT' },
        { name: translate("country.azerbaijan"), code: 'AZ' },
        { name: translate("country.bahamas"), code: 'BS' },
        { name: translate("country.bahrain"), code: 'BH' },
        { name: translate("country.bangladesh"), code: 'BD' },
        { name: translate("country.barbados"), code: 'BB' },
        { name: translate("country.belarus"), code: 'BY' },
        { name: translate("country.belgium"), code: 'BE' },
        { name: translate("country.belize"), code: 'BZ' },
        { name: translate("country.benin"), code: 'BJ' },
        { name: translate("country.bermuda"), code: 'BM' },
        { name: translate("country.bhutan"), code: 'BT' },
        { name: translate("country.bolivia"), code: 'BO' },
        { name: translate("country.bosnia_and_herzegovina"), code: 'BA' },
        { name: translate("country.botswana"), code: 'BW' },
        { name: translate("country.bouvet_island"), code: 'BV' },
        { name: translate("country.brazil"), code: 'BR' },
        { name: translate("country.british_indian_ocean_territory"), code: 'IO' },
        { name: translate("country.brunei_darussalam"), code: 'BN' },
        { name: translate("country.bulgaria"), code: 'BG' },
        { name: translate("country.burkina_faso"), code: 'BF' },
        { name: translate("country.burundi"), code: 'BI' },
        { name: translate("country.cambodia"), code: 'KH' },
        { name: translate("country.cameroon"), code: 'CM' },
        { name: translate("country.canada"), code: 'CA' },
        { name: translate("country.cape_verde"), code: 'CV' },
        { name: translate("country.cayman_islands"), code: 'KY' },
        { name: translate("country.central_african_republic"), code: 'CF' },
        { name: translate("country.chad"), code: 'TD' },
        { name: translate("country.chile"), code: 'CL' },
        { name: translate("country.china"), code: 'CN' },
        { name: translate("country.christmas_island"), code: 'CX' },
        { name: translate("country.cocos_keeling_islands"), code: 'CC' },
        { name: translate("country.colombia"), code: 'CO' },
        { name: translate("country.comoros"), code: 'KM' },
        { name: translate("country.congo"), code: 'CG' },
        { name: translate("country.congo_democratic_republic"), code: 'CD' },
        { name: translate("country.cook_islands"), code: 'CK' },
        { name: translate("country.costa_rica"), code: 'CR' },
        { name: translate("country.cote_divoire"), code: 'CI' },
        { name: translate("country.croatia"), code: 'HR' },
        { name: translate("country.cuba"), code: 'CU' },
        { name: translate("country.cyprus"), code: 'CY' },
        { name: translate("country.czech_republic"), code: 'CZ' },
        { name: translate("country.denmark"), code: 'DK' },
        { name: translate("country.djibouti"), code: 'DJ' },
        { name: translate("country.dominica"), code: 'DM' },
        { name: translate("country.dominican_republic"), code: 'DO' },
        { name: translate("country.ecuador"), code: 'EC' },
        { name: translate("country.egypt"), code: 'EG' },
        { name: translate("country.el_salvador"), code: 'SV' },
        { name: translate("country.equatorial_guinea"), code: 'GQ' },
        { name: translate("country.eritrea"), code: 'ER' },
        { name: translate("country.estonia"), code: 'EE' },
        { name: translate("country.ethiopia"), code: 'ET' },
        { name: translate("country.falkland_islands"), code: 'FK' },
        { name: translate("country.faroe_islands"), code: 'FO' },
        { name: translate("country.fiji"), code: 'FJ' },
        { name: translate("country.finland"), code: 'FI' },
        { name: translate("country.france"), code: 'FR' },
        { name: translate("country.french_guiana"), code: 'GF' },
        { name: translate("country.french_polynesia"), code: 'PF' },
        { name: translate("country.french_southern_territories"), code: 'TF' },
        { name: translate("country.gabon"), code: 'GA' },
        { name: translate("country.gambia"), code: 'GM' },
        { name: translate("country.georgia"), code: 'GE' },
        { name: translate("country.germany"), code: 'DE' },
        { name: translate("country.ghana"), code: 'GH' },
        { name: translate("country.gibraltar"), code: 'GI' },
        { name: translate("country.greece"), code: 'GR' },
        { name: translate("country.greenland"), code: 'GL' },
        { name: translate("country.grenada"), code: 'GD' },
        { name: translate("country.guadeloupe"), code: 'GP' },
        { name: translate("country.guam"), code: 'GU' },
        { name: translate("country.guatemala"), code: 'GT' },
        { name: translate("country.guernsey"), code: 'GG' },
        { name: translate("country.guinea"), code: 'GN' },
        { name: translate("country.guinea_bissau"), code: 'GW' },
        { name: translate("country.guyana"), code: 'GY' },
        { name: translate("country.haiti"), code: 'HT' },
        { name: translate("country.heard_island_and_mcdonald_islands"), code: 'HM' },
        { name: translate("country.holy_see"), code: 'VA' },
        { name: translate("country.honduras"), code: 'HN' },
        { name: translate("country.hong_kong"), code: 'HK' },
        { name: translate("country.hungary"), code: 'HU' },
        { name: translate("country.iceland"), code: 'IS' },
        { name: translate("country.india"), code: 'IN' },
        { name: translate("country.indonesia"), code: 'ID' },
        { name: translate("country.iran"), code: 'IR' },
        { name: translate("country.iraq"), code: 'IQ' },
        { name: translate("country.ireland"), code: 'IE' },
        { name: translate("country.isle_of_man"), code: 'IM' },
        { name: translate("country.israel"), code: 'IL' },
        { name: translate("country.italy"), code: 'IT' },
        { name: translate("country.jamaica"), code: 'JM' },
        { name: translate("country.japan"), code: 'JP' },
        { name: translate("country.jersey"), code: 'JE' },
        { name: translate("country.jordan"), code: 'JO' },
        { name: translate("country.kazakhstan"), code: 'KZ' },
        { name: translate("country.kenya"), code: 'KE' },
        { name: translate("country.kiribati"), code: 'KI' },
        { name: translate("country.korea_democratic"), code: 'KP' },
        { name: translate("country.korea_republic"), code: 'KR' },
        { name: translate("country.kuwait"), code: 'KW' },
        { name: translate("country.kyrgyzstan"), code: 'KG' },
        { name: translate("country.lao"), code: 'LA' },
        { name: translate("country.latvia"), code: 'LV' },
        { name: translate("country.lebanon"), code: 'LB' },
        { name: translate("country.lesotho"), code: 'LS' },
        { name: translate("country.liberia"), code: 'LR' },
        { name: translate("country.libya"), code: 'LY' },
        { name: translate("country.liechtenstein"), code: 'LI' },
        { name: translate("country.lithuania"), code: 'LT' },
        { name: translate("country.luxembourg"), code: 'LU' },
        { name: translate("country.macao"), code: 'MO' },
        { name: translate("country.macedonia"), code: 'MK' },
        { name: translate("country.madagascar"), code: 'MG' },
        { name: translate("country.malawi"), code: 'MW' },
        { name: translate("country.malaysia"), code: 'MY' },
        { name: translate("country.maldives"), code: 'MV' },
        { name: translate("country.mali"), code: 'ML' },
        { name: translate("country.malta"), code: 'MT' },
        { name: translate("country.marshall_islands"), code: 'MH' },
        { name: translate("country.martinique"), code: 'MQ' },
        { name: translate("country.mauritania"), code: 'MR' },
        { name: translate("country.mauritius"), code: 'MU' },
        { name: translate("country.mayotte"), code: 'YT' },
        { name: translate("country.mexico"), code: 'MX' },
        { name: translate("country.micronesia"), code: 'FM' },
        { name: translate("country.moldova"), code: 'MD' },
        { name: translate("country.monaco"), code: 'MC' },
        { name: translate("country.mongolia"), code: 'MN' },
        { name: translate("country.montserrat"), code: 'MS' },
        { name: translate("country.morocco"), code: 'MA' },
        { name: translate("country.mozambique"), code: 'MZ' },
        { name: translate("country.myanmar"), code: 'MM' },
        { name: translate("country.namibia"), code: 'NA' },
        { name: translate("country.nauru"), code: 'NR' },
        { name: translate("country.nepal"), code: 'NP' },
        { name: translate("country.netherlands"), code: 'NL' },
        { name: translate("country.netherlands_antilles"), code: 'AN' },
        { name: translate("country.new_caledonia"), code: 'NC' },
        { name: translate("country.new_zealand"), code: 'NZ' },
        { name: translate("country.nicaragua"), code: 'NI' },
        { name: translate("country.niger"), code: 'NE' },
        { name: translate("country.nigeria"), code: 'NG' },
        { name: translate("country.niue"), code: 'NU' },
        { name: translate("country.norfolk_island"), code: 'NF' },
        { name: translate("country.northern_mariana_islands"), code: 'MP' },
        { name: translate("country.norway"), code: 'NO' },
        { name: translate("country.oman"), code: 'OM' },
        { name: translate("country.pakistan"), code: 'PK' },
        { name: translate("country.palau"), code: 'PW' },
        { name: translate("country.palestinian_territory"), code: 'PS' },
        { name: translate("country.panama"), code: 'PA' },
        { name: translate("country.papua_new_guinea"), code: 'PG' },
        { name: translate("country.paraguay"), code: 'PY' },
        { name: translate("country.peru"), code: 'PE' },
        { name: translate("country.philippines"), code: 'PH' },
        { name: translate("country.pitcairn"), code: 'PN' },
        { name: translate("country.poland"), code: 'PL' },
        { name: translate("country.portugal"), code: 'PT' },
        { name: translate("country.puerto_rico"), code: 'PR' },
        { name: translate("country.qatar"), code: 'QA' },
        { name: translate("country.reunion"), code: 'RE' },
        { name: translate("country.romania"), code: 'RO' },
        { name: translate("country.russia"), code: 'RU' },
        { name: translate("country.rwanda"), code: 'RW' },
        { name: translate("country.saint_helena"), code: 'SH' },
        { name: translate("country.saint_kitts_and_nevis"), code: 'KN' },
        { name: translate("country.saint_lucia"), code: 'LC' },
        { name: translate("country.saint_pierre_and_miquelon"), code: 'PM' },
        { name: translate("country.saint_vincent_and_the_grenadines"), code: 'VC' },
        { name: translate("country.samoa"), code: 'WS' },
        { name: translate("country.san_marino"), code: 'SM' },
        { name: translate("country.sao_tome_and_principe"), code: 'ST' },
        { name: translate("country.saudi_arabia"), code: 'SA' },
        { name: translate("country.senegal"), code: 'SN' },
        { name: translate("country.serbia_and_montenegro"), code: 'CS' },
        { name: translate("country.seychelles"), code: 'SC' },
        { name: translate("country.sierra_leone"), code: 'SL' },
        { name: translate("country.singapore"), code: 'SG' },
        { name: translate("country.slovakia"), code: 'SK' },
        { name: translate("country.slovenia"), code: 'SI' },
        { name: translate("country.solomon_islands"), code: 'SB' },
        { name: translate("country.somalia"), code: 'SO' },
        { name: translate("country.south_africa"), code: 'ZA' },
        { name: translate("country.south_georgia_and_south_sandwich_islands"), code: 'GS' },
        { name: translate("country.spain"), code: 'ES' },
        { name: translate("country.sri_lanka"), code: 'LK' },
        { name: translate("country.sudan"), code: 'SD' },
        { name: translate("country.suriname"), code: 'SR' },
        { name: translate("country.svalbard_and_jan_mayen"), code: 'SJ' },
        { name: translate("country.swaziland"), code: 'SZ' },
        { name: translate("country.sweden"), code: 'SE' },
        { name: translate("country.switzerland"), code: 'CH' },
        { name: translate("country.syria"), code: 'SY' },
        { name: translate("country.taiwan"), code: 'TW' },
        { name: translate("country.tajikistan"), code: 'TJ' },
        { name: translate("country.tanzania"), code: 'TZ' },
        { name: translate("country.thailand"), code: 'TH' },
        { name: translate("country.timor_leste"), code: 'TL' },
        { name: translate("country.togo"), code: 'TG' },
        { name: translate("country.tokelau"), code: 'TK' },
        { name: translate("country.tonga"), code: 'TO' },
        { name: translate("country.trinidad_and_tobago"), code: 'TT' },
        { name: translate("country.tunisia"), code: 'TN' },
        { name: translate("country.turkey"), code: 'TR' },
        { name: translate("country.turkmenistan"), code: 'TM' },
        { name: translate("country.turks_and_caicos_islands"), code: 'TC' },
        { name: translate("country.tuvalu"), code: 'TV' },
        { name: translate("country.uganda"), code: 'UG' },
        { name: translate("country.ukraine"), code: 'UA' },
        { name: translate("country.united_arab_emirates"), code: 'AE' },
        { name: translate("country.united_kingdom"), code: 'GB' },
        { name: translate("country.united_states"), code: 'US' },
        { name: translate("country.united_states_minor_outlying_islands"), code: 'UM' },
        { name: translate("country.uruguay"), code: 'UY' },
        { name: translate("country.uzbekistan"), code: 'UZ' },
        { name: translate("country.vanuatu"), code: 'VU' },
        { name: translate("country.venezuela"), code: 'VE' },
        { name: translate("country.vietnam"), code: 'VN' },
        { name: translate("country.virgin_islands_british"), code: 'VG' },
        { name: translate("country.virgin_islands_us"), code: 'VI' },
        { name: translate("country.wallis_and_futuna"), code: 'WF' },
        { name: translate("country.western_sahara"), code: 'EH' },
        { name: translate("country.yemen"), code: 'YE' },
        { name: translate("country.zambia"), code: 'ZM' },
        { name: translate("country.zimbabwe"), code: 'ZW' }
    ];
}
export default CountryList;